module.exports = __webpack_public_path__ + "img/jianjie (4).ad05e8a6.png";